<template>
  <div class="video-main">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="video-content"
      @click="goDetail(item.uuid, 'type')"
    >
      <van-image class="video-img" :src="item.thumb_img">
        <template v-slot:loading>
          <van-image
            class="default-img"
            :src="require('@/assets/default.png')"
          />
        </template>
        <template v-slot:error
          ><van-image
            class="default-img"
            :src="require('@/assets/default.png')"
        /></template>
      </van-image>
      <van-image class="video-play" :src="require('@/assets/videoPlay.png')">
      </van-image>
      <span class="title" v-html="item.title"></span>
      <span class="player"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: "/video/" + id,
      });
      // const detail = this.$router.resolve({ path: "/video/" + id });
      // window.open(detail.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.video-main {
  width: 725px;
  min-height: calc(100vh - 790px);
  padding-left: 25px;
  text-align: left;
}

.video-content {
  position: relative;
  display: inline-block;
  width: 330px;
  height: auto;
  margin-top: 30px;
  margin-right: 30px;
  vertical-align: top;
  cursor: pointer;
  transition-duration: 0.5s;

  .title {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 333px;
    height: 100px;
    margin-top: 12px;
    overflow: hidden;
    font-size: 28px;
    font-weight: 500;
    line-height: 50px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    ::v-deep span {
      color: rgb(0 71 255 / 100%);
    }
  }

  .player {
    width: 38px;
    height: 38px;
  }

  .video-img {
    width: 333px;
    height: 203px;
    border: 2px solid transparent;
  }
}

.video-play {
  position: absolute;
  top: 80px;
  left: 140px;
  width: 38px;
  height: 38px;
}

.default-img {
  width: 127px;
  height: 82px;
}
</style>
